import * as moment from "moment";

import { ClientScheduleType } from "utils/transformApiSchedule";

import { generateWeeklyDates } from "./utils";

interface ScheduleType extends Pick<ClientScheduleType, "firstPayment"> {
  fallback?: Date[];
}

export default function weeklySampleDates(schedule: ScheduleType): Date[] {
  const defaultFallback = generateWeeklyDates(1);

  const { fallback = defaultFallback, firstPayment } = schedule;

  if (!firstPayment) return fallback;

  return [...Array(5)].map((_, i) =>
    moment(firstPayment)
      .add({ week: i })
      .toDate(),
  );
}
